import { render } from "./Medicine.vue?vue&type=template&id=220ac9aa&scoped=true"
import script from "./Medicine.vue?vue&type=script&lang=js"
export * from "./Medicine.vue?vue&type=script&lang=js"

import "./Medicine.vue?vue&type=style&index=0&id=220ac9aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220ac9aa"]])

export default __exports__